/*
 *  Index Template Scripts
 *    Scripts that are only meant to run on the trade page template.
 *
 *  Version:
 *    1.0.0 - 2020/08/06
 */

// Selectors
export const TRADE_TEMPLATE_CONTAINER = '[data-trade-template]';
export const TRADE_FORM_CONTAINER_SELECTOR = '[data-trade-form-container]';
export const TRADE_FORM_BTN_SELECTOR = '[data-trade-scroll-btn]';
export const TRADE_SAME_AS_BUSINESS_SELECTOR = '[data-trade-same-as-business]';
export const TRADE_SAME_AS_BUSINESS_INPUT_SELECTOR = '[data-trade-same-as-business-field]';

class TradeTemplate {
  constructor(container) {
    this.container = container;
    this.tradeFormContainer = container.find(TRADE_FORM_CONTAINER_SELECTOR);
    this.sameAsBusinessFields = container.find(TRADE_SAME_AS_BUSINESS_INPUT_SELECTOR);

    $(container).on('click', TRADE_FORM_BTN_SELECTOR, (e) => this.goToForm(e));
    $(container).on('click', TRADE_SAME_AS_BUSINESS_SELECTOR, (e) => this.onSameAsBusiness(e))
  }

  goToForm(e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: this.tradeFormContainer.offset().top
    }, 700);
  }

  onSameAsBusiness(e) {
    if($(e.currentTarget).prop('checked') == true) {
      this.sameAsBusinessFields.each((i, e) => {
        let self = $(e);
        self.addClass('is-disabled');
        self.removeAttr('required');
        self.attr('disabled', 'disabled');
      });
    } else {
      this.sameAsBusinessFields.each((i, e) => {
        let self = $(e);
        self.removeClass('is-disabled');
        self.attr('required', 'required');
        self.removeAttr('disabled');
      });
    }

  }
}

$(document).ready($(TRADE_TEMPLATE_CONTAINER).each((i, e) => new TradeTemplate($(e))));